import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import { connect } from 'react-redux';
import { getVideoById, setVideoFilters } from 'shared/actions/journal';
import { DesktopRightSidebar, DesktopButton } from 'shared/components/BannerAll';
import Paginate from 'desktop/components/Paginate/Paginate';
import MakesSidebar from 'desktop/components/MakesSidebar/MakesSidebar';
import VideoList from '../components/VideoList/VideoList';
import s from './Videos.css';

class Videos extends React.Component {
  static propTypes = {
    videos: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    videoOrderBy: PropTypes.string.isRequired,
    getSelVideo: PropTypes.func.isRequired,
    url: PropTypes.string.isRequired,
    query: PropTypes.objectOf(PropTypes.string).isRequired,
    currentPage: PropTypes.number.isRequired,
    pageCount: PropTypes.number.isRequired,
    currentRubric: PropTypes.shape().isRequired,
    makes: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    setDefaultVideoFilters: PropTypes.func.isRequired,
    videoContent: PropTypes.string,
    selVideoParams: PropTypes.shape(),
  };
  static defaultProps = {
    videoContent: '',
    selVideoParams: null,
  };

  componentDidMount() {
    const { selVideoParams } = this.props;
    if (selVideoParams) {
      this.props.getSelVideo(selVideoParams);
    }
  }

  componentWillUnmount() {
    this.props.setDefaultVideoFilters();
  }

  render() {
    const {
      url,
      query,
      videoContent,
      pageCount,
      currentPage,
      currentRubric,
      makes,
      videos,
      videoOrderBy,
      getSelVideo,
      selVideoParams,
    } = this.props;

    return (
      <div className={s.page}>
        <div className={s.container}>
          <div className={s.flexRow}>
            <div className={cx(s.flexCell, s.mainCell)}>
              <VideoList
                videos={videos}
                makes={makes}
                videoContent={videoContent}
                currentRubric={currentRubric}
                videoOrderBy={videoOrderBy}
                getSelVideo={getSelVideo}
                selVideoParams={selVideoParams}
              />
              <DesktopButton />
              {pageCount > 1 && (
                <Paginate pageCount={pageCount} initialPage={currentPage} query={query} url={url} />
              )}
            </div>
            <DesktopRightSidebar scrollNo>
              <MakesSidebar />
            </DesktopRightSidebar>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = ({ globals }) => ({
  videos: globals.journal.news,
  videoTopics: globals.journal.videoTopics,
  videoOrderBy: globals.journal.videoOrderBy,
  selVideoParams: globals.journal.selVideoParams,
  videoContent: globals.journal.selVideoData,
});

const mapDispatchToProps = {
  getSelVideo: getVideoById,
  setDefaultVideoFilters: setVideoFilters,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(s)(Videos));



// WEBPACK FOOTER //
// ./src/desktop/routes/journal/videos/Videos.js